
























































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { schoolYearsOptions } from '../../../../src_server/entity/master/schoolYearsData';
import { weekOptionsShort } from '../../../../src_server/entity/master/weekData';
import { subjectsOptions } from '../../../../src_server/entity/master/subjectsData';
import SimpleSelect from '../../../components/inputs/SimpleSelect.vue';
import SimpleCheckBox from '../../../components/inputs/SimpleCheckBox.vue';
import { Session } from '../../../utils/Session';
import { getTeacherSuffixInSession } from '../../../utils/building_trans';

// 選択しないを追加
const selectDefaultYear = [{ title: '学年を選択してください', value: '' }];

/**
 * 検索条件保持のオブジェクト
 *  チェックボックスは配列
 *  セレクトボックスは文字列
 */
export class SearchCondition {
  school_year = '';
  subject: string[] = [];
  day_of_week: string[] = [];
  deafness: string[] = [];
  handSign: string[] = [];
  favorite = false;
  now_available = false;
}
@Component({ components: { SimpleSelect, SimpleCheckBox } })
export default class LessonListSearchPanel extends Vue {
  @Prop({ default: new SearchCondition() })
  defaultCondition!: SearchCondition;

  get searchCondition(): SearchCondition {
    return this.defaultCondition;
  }

  set searchCondition(value: SearchCondition) {
    this.$emit('on-condition-change', value);
  }

  get teacherSuffix() {
    return getTeacherSuffixInSession();
  }

  // オプションを取得する
  get schoolYearsOP() {
    return [...selectDefaultYear, ...schoolYearsOptions];
  }
  get weeksOP() {
    return weekOptionsShort;
  }

  get subjectsOP() {
    return subjectsOptions;
  }
  get deffnessOP() {
    return [
      { value: 'Listener', title: '聴者' },
      { value: 'HardHearing', title: '難聴者' },
      { value: 'Deaf', title: 'ろう者' },
    ];
  }

  get handSginOP() {
    return [{ value: '音声対話', title: '音声対話' }];
  }
}
